import {combineReducers} from "redux";
import userReducer from "./user";


export default combineReducers({
user: userReducer

});


// WEBPACK FOOTER //
// ./src/reducers/index.js